var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 6.78378V7.58857C25.6667 8.79939 25.6667 9.40479 25.3638 9.90667C25.061 10.4085 24.5077 10.72 23.401 11.343L20.0025 13.2561C19.26 13.6741 18.8888 13.8831 18.6229 14.1139C18.0694 14.5944 17.7286 15.1591 17.5742 15.8517C17.5 16.1843 17.5 16.5735 17.5 17.3518V20.4662C17.5 22.6939 17.5 23.8077 16.7208 24.2951C15.9415 24.7825 14.8456 24.3541 12.6539 23.4973C11.6099 23.0892 11.0879 22.8851 10.794 22.4715C10.5 22.0579 10.5 21.5273 10.5 20.4662L10.5 17.3518C10.5 16.5734 10.5 16.1843 10.4259 15.8517C10.2715 15.1591 9.93069 14.5944 9.37714 14.1139C9.11132 13.8831 8.74008 13.6741 7.99759 13.2561L4.59906 11.343C3.49243 10.72 2.93911 10.4085 2.63624 9.90667C2.33337 9.40479 2.33337 8.79939 2.33337 7.58857V6.78378",
    stroke: "#4D4D5E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.6667 6.78377C25.6667 5.23579 25.6667 4.46179 25.1541 3.9809C24.6416 3.5 23.8166 3.5 22.1667 3.5H5.83337C4.18346 3.5 3.3585 3.5 2.84594 3.9809C2.33337 4.46179 2.33337 5.23579 2.33337 6.78377",
    stroke: "#4D4D5E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.43bbfc01d85d26033fa350f3bd6dc77d.svg";
export { ForwardRef as ReactComponent };